module.exports = __webpack_public_path__ + "media/images/icon/caret-down-black-ed4ad4628edf7f256c215809bd5d3fd6.svg";